import { toast } from "sonner";
import { Link2, Linkedin, MessageCircle, Twitter } from "lucide-react";

const btn = "h-9 w-9 grid place-items-center border border-border hover:border-primary hover:text-primary transition-colors";

export const ShareBar = ({ title, url, shareUrl = url, id = "top" }) => {
  const u = encodeURIComponent(shareUrl);
  const t = encodeURIComponent(title);
  const copy = () => navigator.clipboard?.writeText(url).then(() => toast.success("Enlace copiado"));
  return (
    <div className="flex items-center gap-2" data-testid={`share-bar-${id}`}>
      <span className="kicker text-muted-foreground mr-1">Compartir</span>
      <a className={btn} href={`https://twitter.com/intent/tweet?url=${u}&text=${t}`} target="_blank" rel="noopener noreferrer" aria-label="Compartir en X" data-testid={`share-x-${id}`}><Twitter className="h-4 w-4" /></a>
      <a className={btn} href={`https://www.linkedin.com/sharing/share-offsite/?url=${u}`} target="_blank" rel="noopener noreferrer" aria-label="Compartir en LinkedIn" data-testid={`share-linkedin-${id}`}><Linkedin className="h-4 w-4" /></a>
      <a className={btn} href={`https://wa.me/?text=${t}%20${u}`} target="_blank" rel="noopener noreferrer" aria-label="Compartir en WhatsApp" data-testid={`share-whatsapp-${id}`}><MessageCircle className="h-4 w-4" /></a>
      <button className={btn} onClick={copy} aria-label="Copiar enlace" data-testid={`share-copy-${id}`}><Link2 className="h-4 w-4" /></button>
    </div>
  );
};
